import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { TIMELINE, IMAGES } from "../../data";

export const Heritage = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section
      id="heritage"
      ref={ref}
      data-testid="heritage-section"
      className="relative bg-[#1A1714] border-y border-[#2C2621] overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-28 md:py-40 grid grid-cols-1 lg:grid-cols-12 gap-16">
        {/* Left: image */}
        <div className="lg:col-span-5 relative">
          <div className="relative overflow-hidden h-[420px] md:h-[560px]">
            <motion.img
              style={{ y }}
              src={IMAGES.heritageBrick}
              alt="Heritage architecture"
              className="w-full h-[130%] object-cover -mt-[10%]"
            />
            <div className="absolute inset-0 bg-[#12100E]/30" />
          </div>
          <div className="absolute -bottom-8 -right-4 md:right-8 bg-[#12100E] border border-[#2C2621] px-8 py-6">
            <span className="font-serif-lux text-5xl md:text-6xl text-[#D49A44] leading-none">1911</span>
            <p className="font-sans-lux text-[10px] uppercase tracking-[0.3em] text-[#7C756B] mt-2">
              The year it began
            </p>
          </div>
        </div>

        {/* Right: timeline */}
        <div className="lg:col-span-7 lg:pl-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="font-sans-lux text-xs uppercase tracking-[0.3em] text-[#D49A44] mb-6">
              Our Heritage
            </p>
            <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-tight tracking-tight text-[#F4EFE6] mb-12">
              A century of trust, <span className="italic text-[#D49A44]">measured in aroma.</span>
            </h2>
          </motion.div>

          <div className="space-y-0">
            {TIMELINE.map((t, i) => (
              <motion.div
                key={t.year}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                className="grid grid-cols-[80px_1fr] md:grid-cols-[120px_1fr] gap-6 py-6 border-t border-[#2C2621] last:border-b"
              >
                <span className="font-serif-lux text-xl md:text-2xl text-[#D49A44]">{t.year}</span>
                <p className="font-sans-lux text-sm md:text-base text-[#B0A89D] leading-relaxed">
                  {t.text}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
